import React, { Fragment, useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FAddressCard from "../../components/FAddressCard/FAddressCard";
import { getAddress, deleteAddressById } from "../../api/address";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import FInput from "../../components/FInput/FInput";
import { useFormik } from "formik";
import { getCountries } from "../../api/countries";
import { getBankInfo, postBanks } from "../../api/banks";
import { AuthContext } from "../../context/AuthContext";
import { useContactInfo } from "../../hooks/useContactInfo";
import { getWordOfDictionary } from "../../common/dictionary";
import Select from "react-select";
import { PlusCircleIcon } from "@heroicons/react/outline";
import FContainer from "../../components/FContainer/FContainer";
import Fselect from "../../components/Finputs/Fselect/Fselect";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import { AddCircleOutline, MailOutline } from "react-ionicons";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

const CreateBankScreen = ({ param }) => {
  const route = useNavigate();

  const { setLoading, setError, setPreviousScreenDefinite,checkToken } =
    useContext(AuthContext);

  const [countryId, setCountryId] = useState("52");
  const [countryCode, setCountryCode] = useState("");
  const [banks, setBanks] = useState([]);
  const [bankId, setBankId] = useState([]);
  const { emails, getEmails, emailMapSelect } = useContactInfo();
  const [emailId, setEmailId] = useState("");

  const createBank = async ({
    bankId,
    alias,
    accountDefault,
    accountTypeId,
    accountNumber,
    email,
    routingNumber,
    countryId,
  }) => {
    checkToken()
    try {
      setLoading(true);
      const { data } = await postBanks({
        bankId,
        alias,
        accountDefault,
        accountTypeId,
        accountNumber,
        email,
        routingNumber,
        countryId,
      });
      setLoading(false);
      return [true];
    } catch (e) {
      setLoading(false);
      setError(getWordOfDictionary(e.response.data.code));
      return [false, e.response.data.code];
    }
  };

  const nextScreen = async ({
    bankId,
    alias,
    accountDefault,
    accountTypeId,
    accountNumber,
    email,
    routingNumber,
    countryId,
  }) => {
    const resp = await createBank({
      bankId,
      alias,
      accountDefault,
      accountTypeId,
      accountNumber,
      email,
      routingNumber,
      countryId,
    });

    

    if (resp[0]) {
      Swal.fire({
        showCloseButton: true,
        title: "Confirmado",
        text: "Se ha agregado el banco",
        icon: "success",
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Custom image",
        confirmButtonColor: "#28a745",
        confirmButtonText: "Aceptar",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          route(-1);
        }
      });
    } else {
      if (resp[1] == "DOCUMENT_NOT_FOUND") {
        Swal.fire({
          showCloseButton: true,
          title: "Lo sentimos",
          text: "Para realizar esta acción requiere de que el proceso kyc este aprobado",
          icon: "warning",
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: "Custom image",
          confirmButtonColor: "#28a745",
          confirmButtonText: "Aceptar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            route(-1);
          }
        });
      } else {
        Swal.fire({
          showCloseButton: true,
          title: "Lo sentimos",
          text: "Hubo un problema al realizar la operación. Por favor intente de nuevo.",
          icon: "warning",
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: "Custom image",
          confirmButtonColor: "#28a745",
          confirmButtonText: "Aceptar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            route(-1);
          }
        });
      }
    }
  };
  const parameters = useLocation();

  const [selectedCountryOption, setSelectedCountryOption] = useState();
  const [CountryOption, setCountryOption] = useState();

  const [selectedMXBankOption, setSelectedMXBankOption] = useState();
  const [MXBankOption, setMXBankOption] = useState([]);

  useEffect(() => {
    getEmails();
    _getCountries();
    _getBankInfo();
  }, []);

  useEffect(() => {
    formikAddress.setFieldValue(
      "countryId",
      !CountryOption ? "" : CountryOption[0].id
    );
  }, [CountryOption]);

  useEffect(() => {
    formikAddress.setFieldValue(
      "email",
      emailMapSelect.length > 0 ? emailMapSelect[0].id : ""
    );
  }, [emailMapSelect]);

  async function _getCountries() {
   // checkToken()
    let _return = false;
    //setLoading(true);
    try {

      let countries = [
            {
              id: "484",
              value: "Mexico",
              ico: require(`../../components/assets/images/MX.png`),
            },
            {
              id: "840",
              value: "USA",
              ico: require(`../../components/assets/images/US.png`),
            },

      ]

      setCountryOption(countries);
      
      // const dataGetCountries = await getCountries();
      // setLoading(false);
      // const res = dataGetCountries.data;
      // console.log(res);
      // if (res.code == "PROCESS_OK") {
      //   var _data = res.data.map(function (dta) {
      //     return {
      //       id: dta.id,
      //       value: dta.name,
      //       ico: require(`../../components/assets/images/${dta.iso2}.png`),
      //     };
      //   });
      //   setCountryOption(_data);
      //}
    } catch (error) {
      // setLoading(false);
      // const res = error.response.data;
      // if (res.code == "NOT_FOUND") {
      //   // Swal.fire({
      //   //   title: "Código incorrecto",
      //   //   text: "",
      //   //   imageUrl: require("../../components/assets/images/advertir.png"),
      //   //   imageWidth: 150,
      //   //   imageHeight: 150,
      //   //   confirmButtonColor: "#fd6e0d",
      //   // });
      // }
    }
    return _return;
  }

  const formikAddress = useFormik({
    initialValues: {
      bankId: "",
      accountDefault: false,
      accountTypeId: 1,
      accountNumber: "",
      email: "",
      routingNumber: "",
      countryId: "",
      alias: "",
    },
    onSubmit: async (values) => {
      const {
        bankId,
        accountDefault,
        accountTypeId,
        accountNumber,
        email,
        routingNumber,
        alias,
        countryId,
      } = values;
      if (countryId != "840") {
        nextScreen({
          bankId,
          alias: null,
          accountDefault,
          accountTypeId,
          accountNumber,
          email: null,
          routingNumber: null,
          countryId,
        });
      } else {
        nextScreen({
          bankId: null,
          alias,
          accountDefault,
          accountTypeId,
          accountNumber,
          email,
          routingNumber,
          countryId,
        });
      }
    },
    validate: (values) => {
      const errors = {};
      if (values.countryId == "484") {
        if (!values.bankId) errors.bankId = "Selecciona tu banco";
        if (!values.accountNumber) errors.accountNumber = "Ingresa tu cuenta";
        if (values.accountNumber && values.accountNumber.length < 18)
          errors.accountNumber = "Debe tener 18 caracteres";
      }

      if (values.countryId == "840") {
        if (!values.alias) errors.alias = "Ingresa el nombre del banco";
        if (!values.accountNumber)
          errors.accountNumber = "Ingresa tu número de Cuenta";

        if (!values.routingNumber)
          errors.routingNumber = "Ingresa tu routing Number";
        if (values.routingNumber && values.routingNumber.length < 9)
          errors.routingNumber = "Debe tener 9 caracteres";

        if (!values.email) errors.email = "Este campo es requerido";
      }
      return errors;
    },
  });

  function compare_lname(a, b) {
    if (a.value.toLowerCase() < b.value.toLowerCase()) {
      return -1;
    }
    if (a.value.toLowerCase() > b.value.toLowerCase()) {
      return 1;
    }
    return 0;
  }

  const ChangeSelectedMXBank = (e) => {
    //console.log(e);
    setSelectedMXBankOption(e);
    formikAddress.setFieldValue("bankId", e.value);
  };

  async function _getBankInfo() {
    checkToken()
    let _return = false;
    setLoading(true);
    try {
      const dataGetBankInfo = await getBankInfo(52);
      setLoading(false);
      const res = dataGetBankInfo.data;
      if (res.code == "PROCESS_OK") {
        var _data = res.data.map(function (dta) {
          return {
            id: dta.id,
            value: dta.name,
            ico: null,
          };
        });

        _data.sort(compare_lname);
        setMXBankOption(_data);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }

  return (
    <>
      <div className="w-full font-bold text-Secondary text-[5vw] sm:text-[25px] border-0 text-center">
        Asocia tu cuenta bancaria
      </div>
      {/* <Floading open={true}></Floading> */}
      {!CountryOption ? <Floading open={true}></Floading> :
        (<FContainer>
          {!CountryOption ? null : (
            <Fselect
              type="SelectIcon"
              title="Selecciona tu país"
              placeholder="Selecciona tu país"
              value={CountryOption[0]}
              options={CountryOption}
              onChange={(val) => {
                formikAddress.setFieldValue("countryId", val.id);
              }}
            />
          )}
          {/* formikAddress.values.countryId == "484" */}
          {!MXBankOption ? null : (
            <div
              className={`w-full ${formikAddress.values.countryId == "840" ? "hidden" : ""
                }`}
            >
              <Fselect
                type="SelectIcon"
                title="Selecciona tu banco"
                placeholder="Selecciona tu banco"
                options={MXBankOption}
                onChange={(val) => {
                  formikAddress.setFieldValue("bankId", val.id);
                }}
                errorMessage={formikAddress.values.bankId == "" ? "" : formikAddress.errors.bankId}
              />
            </div>
          )}
          <div
            className={`w-full ${formikAddress.values.countryId == "484" ? "hidden" : ""
              }`}
          >
            <FInputText
              title="Nombre de tu banco"
              placeholder="Nombre de tu banco"
              maxLength={20}
              onChange={(val) => {
                formikAddress.setFieldValue("alias", val);
              }}
              errorMessage={formikAddress.values.alias == "" ? "" : formikAddress.errors.alias}
            />
          </div>

          <FInputText
            type="NumberInput"
            title={
              formikAddress.values.countryId == "484"
                ? "Cuenta Clabe"
                : "Número de cuenta"
            }
            placeholder={
              formikAddress.values.countryId == "484"
                ? "Cuenta Clabe"
                : "Número de cuenta"
            }
            maxLength={18}
            onChange={(val) => {
              formikAddress.setFieldValue("accountNumber", val);
            }}
            errorMessage={formikAddress.values.accountNumber == "" ? "" : formikAddress.errors.accountNumber}
          />
          <div
            className={`w-full ${formikAddress.values.countryId == "484" ? "hidden" : ""
              }`}
          >
            <FInputText
              type="NumberInput"
              title="Routing number"
              placeholder="Routing number"
              maxLength={9}
              onChange={(val) => {
                formikAddress.setFieldValue("routingNumber", val);
              }}
              errorMessage={formikAddress.values.routingNumber == "" ? "" : formikAddress.errors.routingNumber}
            />
          </div>
          <div
            className={`w-full ${formikAddress.values.countryId == "484" ? "hidden" : ""
              }`}
          >
            {emailMapSelect.length > 0 ? (
              <>
                <div className="border-0 col-span-1 z-50 grid grid-cols-12">
                  <div className="border-0 col-span-12">
                    {!emailMapSelect ? null : (
                      <Fselect
                        type="SelectIcon"
                        title="Selecciona tu Email"
                        placeholder="Selecciona tu Email"
                        value={emailMapSelect[0]}
                        options={emailMapSelect}
                        onChange={(value) => {
                          formikAddress.setFieldValue("email", value.value);
                        }}
                      />
                    )}
                  </div>
                </div>

                <div
                  className="border-0 w-full font-bold text-Secondary text-[4vw] smm:text-[17px] py-2 grid place-items-end cursor-pointer"
                  onClick={() => {
                    setPreviousScreenDefinite(-1);
                    route("/CreateEmailScreen");
                  }}
                >
                  Agregar nuevo email
                </div>
              </>
            ) : (
              <div className="border-0 col-span-1">
                <div
                  className="border-3 grid grid-cols-1 rounded-2xl py-2 my-2 shadow-Box cursor-pointer"
                  onClick={() => {
                    setPreviousScreenDefinite(-1);
                    route("/CreateEmailScreen");
                  }}
                >
                  <div className="border-0 col-span-1 grid place-items-center">
                    <MailOutline width="35px" height="35px" />
                  </div>
                  <div className="border-0 col-span-1 text-center font-semibold text-[3.5vw] smm:text-[15px]">
                    Agregar correo
                  </div>
                </div>
                <p className="text-error font-bold text-left text-small">
                  {formikAddress.errors.email}
                </p>
              </div>
            )}
          </div>
          <Fbutton
            value={"Crear cuenta"}
            disabled={!(formikAddress.isValid && formikAddress.dirty)}
            onClick={formikAddress.handleSubmit}
          />
        </FContainer>)}

    </>
  );
};

export default CreateBankScreen;
